import React from "react";
import styles from "./FeaturedHalfs.module.scss";
import Link from "gatsby-link";



const FeaturedHalfs = ({ articles, style }) => {
	const items = articles.map(({ node }, idx) => {
		return (
			<li
				key={idx}
				className={styles.list_news_grid__item + " mb-4"}
				style={{
					backgroundImage:
						"url(" + node.featuredImage.sizes.src + ")",
					
				}}
			>
				<div className="row ">
					<div
						className={
							"col-12 col-lg-8 " + styles.listen_news_grid__item_inner
						}
					>
						<span className={styles.list_news_grid__category}>
							{node.researchArea.title}
						</span>{" "}
						<h5>
							<Link
								to={`/${node.node_locale}/research/story/${
									node.slug
								}/`}
								className="list_news_grid__link"
							>
								{node.title}
							</Link>
						</h5>
						<span className={styles.list_news_grid__excerpt}>
							<p>
								{node.content.childMarkdownRemark.excerpt}
							</p>
						</span>
					</div>
				</div>
			</li>
		);
	});
	return (
		<div className={styles.outer_wrapper}>
			<div className="container py-lg-3">
				<div className="row no-gutters ">
					<div className="col">
						<ul className={styles.list_news_grid}>{items}</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FeaturedHalfs;



// WEBPACK FOOTER //
// ./src/components/FeaturedHalfs/index.js